import ReactDOM from "react-dom";
import "./styles/reset.css"
import "./styles/style.css"
import App from "./App";

ReactDOM.render(<App/>, document.querySelector(".root"))